export enum PinProtectionLevel {
  Account = 'Account',
  Profile = 'Profile'
}
